import { FunctionComponent } from 'react'
import CreationToolOutputType from 'creation/src/creation-tools/types/output-type'
import { GifIcon, IconProps, StickerIcon, VideoIcon } from '../components/icons'
import CreationToolGradient from './gradient'

const icons: Record<CreationToolOutputType, FunctionComponent<IconProps>> = {
    [CreationToolOutputType.Sticker]: StickerIcon,
    [CreationToolOutputType.Gif]: GifIcon,
    [CreationToolOutputType.Video]: VideoIcon,
}

const gradients: Record<CreationToolOutputType, CreationToolGradient> = {
    [CreationToolOutputType.Sticker]: CreationToolGradient.BlueGreen,
    [CreationToolOutputType.Gif]: CreationToolGradient.IndigoPurple,
    [CreationToolOutputType.Video]: CreationToolGradient.IndigoPurple,
}

/**
 * Returns the output type's icon react component.
 */
export const outputTypeIcon = (type: CreationToolOutputType): FunctionComponent<IconProps> => icons[type]

/**
 * Returns the output type's gradient colors.
 */
export const outputTypeGradient = (type: CreationToolOutputType): CreationToolGradient => gradients[type]

export default CreationToolOutputType
